import { createSelector } from 'reselect';

const selectUserState = (state) => state.user;

export const getAuthenticatedUser = createSelector([selectUserState], (user) => user.isAuthenticated);
export const getCurrentUser = createSelector([selectUserState], (user) => user.user);
